import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

export const LayoutTextFlip = ({
  text,
  words,
  duration = 3000,
}: {
  text: string;
  words: string[];
  duration?: number;
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, duration);

    return () => clearInterval(interval);
  }, [words.length, duration]);

  return (
    <>
      <motion.span
        layoutId="subtext"
        className="text-2xl font-semibold tracking-tight drop-shadow-lg"
      >
        {text}
      </motion.span>

      <motion.span
        layout
        className={cn(
          'relative w-fit overflow-hidden rounded-md border border-transparent',
          'bg-white px-4 py-2 text-2xl font-semibold tracking-tight text-black',
          'shadow-sm ring shadow-black/10 ring-black/10 drop-shadow-lg',
        )}
      >
        <AnimatePresence mode="popLayout">
          <motion.span
            key={currentIndex}
            initial={{ y: -40, filter: 'blur(10px)' }}
            animate={{
              y: 0,
              filter: 'blur(0px)',
            }}
            exit={{ y: 50, filter: 'blur(10px)', opacity: 0 }}
            transition={{
              duration: 0.5,
            }}
            className={cn('inline-block whitespace-nowrap')}
          >
            {words[currentIndex]}
          </motion.span>
        </AnimatePresence>
      </motion.span>
    </>
  );
};
